import React, { Suspense } from 'react';
import styled from 'styled-components';
import { GenericTopBar } from '../base/GenericTopBar';
import { Route, Routes } from 'react-router-dom';

const OktaTutorial = React.lazy(() => import('./OktaTutorial'));

const Container = styled.div`
    background-color: ${props => props.theme.backgroundColor};
    min-height: 100vh;
    max-height: 100vh;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 54px calc(100vh - 54px);
    grid-template-areas:
        'top-bar'
        'graph-list';
`;

const Main = styled.main`
    grid-area: graph-list;
`;

interface Props {}

export const TutorialLayout: React.FC<Props> = props => {
    return (
        <Container>
            <GenericTopBar title="Tutorials" />
            <Main>
                <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                        <Route path="/okta" element={<OktaTutorial />} />
                    </Routes>
                </Suspense>
            </Main>
        </Container>
    );
};
